<template>
	<div class="m-4">
		<div class="text-subtitle-2">{{ $t("dashboard.eventSettings") }}</div>
		<div class="grid grid-cols-2 gap-4">
			<SoftSelect
				v-model="accelerationUnit"
				:label="$t('dashboard.units.acceleration')"
				:items="accUnits"
			/>
			<SoftSelect
				v-model="velocityUnit"
				:label="$t('dashboard.units.velocity')"
				:items="velUnits"
			/>
		</div>
		<SoftSelect
			v-model="vibrationType"
			class="mt-2"
			:label="$t('dashboard.waveformType')"
			:items="vibrationTypes"
			itemText="name"
			itemValue="value"
		/>
		<SoftSelect v-model="oplUnit" :label="$t('dashboard.units.overpressure')" :items="oplUnits" />
	</div>
</template>

<script lang="ts">
import { useDataCatalog } from "@/composable/data-catalog";
import { accelerationUnits, overpressureUnits, velocityUnits } from "@soft-db/data-formatter";
import { useModelValue, useRefObjectSync } from "@soft-db/soft-utils";
import { computed, defineComponent, PropType } from "vue";
import { defaultVibEventDataOptions, VibEventDataOptions } from "./vib-event-data-config";

export default defineComponent({
	name: "VibEventDataConfig",
	props: {
		modelValue: {
			type: Object as PropType<VibEventDataOptions>,
			default: () => ({ ...defaultVibEventDataOptions }),
		},
	},
	setup(props) {
		const valueModel = useModelValue(props);

		const vibrationType = useRefObjectSync(valueModel, "vibrationType");
		const accelerationUnit = useRefObjectSync(valueModel, "accelerationUnit");
		const velocityUnit = useRefObjectSync(valueModel, "velocityUnit");
		const oplUnit = useRefObjectSync(valueModel, "oplUnit");

		const { generateMenuEntries, VibrationSubType } = useDataCatalog();

		const vibrationTypes = generateMenuEntries(VibrationSubType);

		const velUnits = computed(() => [...velocityUnits]);
		const accUnits = computed(() => [...accelerationUnits]);
		const oplUnits = computed(() => [...overpressureUnits.filter((element) => element !== "dB")]);

		return {
			vibrationType,
			vibrationTypes,
			accelerationUnit,
			accUnits,
			velocityUnit,
			velUnits,
			oplUnit,
			oplUnits,
		};
	},
});
</script>
